import {AppBar, AppBarSection,AppBarSpacer} from "@progress/kendo-react-layout"
import logo from "../Jamboree_2026_logo_BC.svg"
export const AdminNav=()=>{
    return(
        <AppBar themeColor="dark">
            <AppBarSection>
                <img src={logo} alt="Logo" style={{width:"50px", height:"auto"}}/>
            </AppBarSection>
            <AppBarSection>
                <h1 className="title">NSJ Adventure Program Management</h1>
            </AppBarSection>
        </AppBar>
    )
}

export const TitleBar=({title})=>{
    return(
        <AppBar themeColor="dark">
            <AppBarSection>
                <img src={logo} alt="Logo" style={{width:"50px", height:"auto"}}/>
            </AppBarSection>
            <AppBarSection>
                <h1 className="title">{title!=""?title:"Program Wait Times"}</h1>
            </AppBarSection>
        </AppBar>
    )
}

export const AreaTitle=({area})=>{
    return(
        <AppBar themeColor="dark">
            <AppBarSection>
                <img src={logo} alt="Logo" style={{width:"50px", height:"auto"}}/>
            </AppBarSection>
            <AppBarSection>
                <h2 className="title">{area}</h2>
            </AppBarSection>
        </AppBar>
    )
}

